import { Router, type CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { MenuService } from '../services/menu.service';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const menu = inject(MenuService);
  const auth = inject(AuthService);

  menu.selectedMenu(state.url || '/');

  if (!auth.isAuthenticated()) {
    auth.login();
    return false;
  }

  const requiredRoles = auth.getRequiredRoles(route);
  if (!auth.hasRequiredRoles(requiredRoles)) {
    return router.parseUrl('/forbidden');
  }

  return true;
};
